/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  FCAFuelSurchargeValuesInput,
  FcaFuelSurchargeValues,
  FuelSurchargeValueDTO,
  FuelSurchargeValueHistory,
  FuelSurchargeValuesInput,
} from "../models/index";
import {
  FCAFuelSurchargeValuesInputFromJSON,
  FCAFuelSurchargeValuesInputToJSON,
  FcaFuelSurchargeValuesFromJSON,
  FcaFuelSurchargeValuesToJSON,
  FuelSurchargeValueDTOFromJSON,
  FuelSurchargeValueDTOToJSON,
  FuelSurchargeValueHistoryFromJSON,
  FuelSurchargeValueHistoryToJSON,
  FuelSurchargeValuesInputFromJSON,
  FuelSurchargeValuesInputToJSON,
} from "../models/index";

export interface DeleteFuelSurchargeValueRequest {
  fuelSurchargeValueId: string;
}

export interface EditFuelSurchargeValueRequest {
  fuelSurchargeValuesInput: FuelSurchargeValuesInput;
}

export interface GetHistoryRecordsForIdRequest {
  fuelSurchargeValueId: string;
}

export interface InsertFCAFuelSurchargeValueRequest {
  fCAFuelSurchargeValuesInput: FCAFuelSurchargeValuesInput;
}

export interface InsertFuelSurchargeValueRequest {
  fuelSurchargeValuesInput: FuelSurchargeValuesInput;
}

/**
 *
 */
export class FuelSurchargeValuesApi extends runtime.BaseAPI {
  /**
   */
  async deleteFuelSurchargeValueRaw(
    requestParameters: DeleteFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["fuelSurchargeValueId"] == null) {
      throw new runtime.RequiredError(
        "fuelSurchargeValueId",
        'Required parameter "fuelSurchargeValueId" was null or undefined when calling deleteFuelSurchargeValue().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["fuelSurchargeValueId"] != null) {
      queryParameters["fuelSurchargeValueId"] =
        requestParameters["fuelSurchargeValueId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/delete-fuel-surcharge-value`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteFuelSurchargeValue(
    requestParameters: DeleteFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteFuelSurchargeValueRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editFuelSurchargeValueRaw(
    requestParameters: EditFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["fuelSurchargeValuesInput"] == null) {
      throw new runtime.RequiredError(
        "fuelSurchargeValuesInput",
        'Required parameter "fuelSurchargeValuesInput" was null or undefined when calling editFuelSurchargeValue().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/edit-fuel-surcharge-value`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FuelSurchargeValuesInputToJSON(
          requestParameters["fuelSurchargeValuesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editFuelSurchargeValue(
    requestParameters: EditFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editFuelSurchargeValueRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAllFCAFuelSurchargeValuesHistoryRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<FcaFuelSurchargeValues>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/get-all-fca-fuel-surcharge-values-history`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FcaFuelSurchargeValuesFromJSON),
    );
  }

  /**
   */
  async getAllFCAFuelSurchargeValuesHistory(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<FcaFuelSurchargeValues>> {
    const response =
      await this.getAllFCAFuelSurchargeValuesHistoryRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getAllFuelSurchargeValuesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<FuelSurchargeValueDTO>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/get-all-fuel-surcharge-values`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FuelSurchargeValueDTOFromJSON),
    );
  }

  /**
   */
  async getAllFuelSurchargeValues(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<FuelSurchargeValueDTO>> {
    const response = await this.getAllFuelSurchargeValuesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getHistoryRecordsForIdRaw(
    requestParameters: GetHistoryRecordsForIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<FuelSurchargeValueHistory>>> {
    if (requestParameters["fuelSurchargeValueId"] == null) {
      throw new runtime.RequiredError(
        "fuelSurchargeValueId",
        'Required parameter "fuelSurchargeValueId" was null or undefined when calling getHistoryRecordsForId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["fuelSurchargeValueId"] != null) {
      queryParameters["fuelSurchargeValueId"] =
        requestParameters["fuelSurchargeValueId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/history-for-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FuelSurchargeValueHistoryFromJSON),
    );
  }

  /**
   */
  async getHistoryRecordsForId(
    requestParameters: GetHistoryRecordsForIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<FuelSurchargeValueHistory>> {
    const response = await this.getHistoryRecordsForIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertFCAFuelSurchargeValueRaw(
    requestParameters: InsertFCAFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["fCAFuelSurchargeValuesInput"] == null) {
      throw new runtime.RequiredError(
        "fCAFuelSurchargeValuesInput",
        'Required parameter "fCAFuelSurchargeValuesInput" was null or undefined when calling insertFCAFuelSurchargeValue().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/insert-fca-fuel-surcharge-value`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FCAFuelSurchargeValuesInputToJSON(
          requestParameters["fCAFuelSurchargeValuesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertFCAFuelSurchargeValue(
    requestParameters: InsertFCAFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertFCAFuelSurchargeValueRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertFuelSurchargeValueRaw(
    requestParameters: InsertFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["fuelSurchargeValuesInput"] == null) {
      throw new runtime.RequiredError(
        "fuelSurchargeValuesInput",
        'Required parameter "fuelSurchargeValuesInput" was null or undefined when calling insertFuelSurchargeValue().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/fuel-surcharge-values/insert-fuel-surcharge-value`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FuelSurchargeValuesInputToJSON(
          requestParameters["fuelSurchargeValuesInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertFuelSurchargeValue(
    requestParameters: InsertFuelSurchargeValueRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertFuelSurchargeValueRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
